import en from '../../../../lang/en-us';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { ErrorSectionTypes } from '../ExploreMFs/types';
import KycDetailsPurchase from './KycDetailsPurchase';
import { PurchaseDetailsBox } from './PurchaseDetailsBox';
const { dbCommercial, dashboard } = en;

export const getCountryNameFromCode = (countryData: any, code: string) => {
    const country = countryData.find((country: any) => country.code === code);
    return country?.name;
};

const taxDetailUIData = (countryData: any, taxData: any) => {
    let uiData = taxData.map((tax: any, index: number) => {
        return (
            <li key={index}>
                <div className="box-details dotted-box">
                    <div className="dotted-first-col">
                        <p>ID - {index + 1} </p>
                    </div>
                    <div className="box-details-info">
                        <p>Country of Tax Residency - </p>
                        <h6>{getCountryNameFromCode(countryData, tax.country)}</h6>
                    </div>
                    <div className="box-details-info">
                        <p>Tax ID - </p>
                        <h6>{tax.taxId || (tax.tinReason && 'NA')}</h6>
                    </div>
                    <div className="box-details-info">
                        <p>Identification Type - </p>
                        <h6>{tax.idType || (tax.tinReason && 'Unavailable')}</h6>
                    </div>
                </div>
            </li>
        );
    });
    return <ul> {uiData} </ul>;
};

export default function FatcaDetailsPurchase(props: any) {
    const { countryData, apiData } = props;
    const data = apiData.fatcaDetails.find((fatca: any) => fatca.fatcaId === 'FH') || {};
    const formattedFatcaData =
        (data.taxResidencyOtherthanIndia || data.declartion) === IsAllow.No
            ? [
                {
                    label: dashboard.FatcaDeclaration.taxResident,
                    value: 'No',
                    isEditable: false,
                    name: 'declaration',
                    apiKey: 'declaration',
                },
            ]
            : [
                {
                    label: dashboard.FatcaDeclaration.countryOfBirth,
                    value: data.countryBirth || 'NA',
                    isEditable: false,
                    name: 'countryOfBirth',
                    apiKey: 'countryOfBirth',
                },
                {
                    label: dashboard.FatcaDeclaration.nationality,
                    value: data.nationality || 'NA',
                    isEditable: false,
                    name: 'nationality',
                    apiKey: 'nationality',
                },
            ];

    return (
        <div className="purchase-section">
            <h2>{dbCommercial.newPurchase.leftMenu.fatcaKyc}</h2>
            <PurchaseDetailsBox
                boxDetails={formattedFatcaData}
                heading={`FATCA Details`}
                editRedirect={`${props.isin}/edit/fatca`}
                extraDetails={
                    (data?.taxResidencyOtherthanIndia || data.declaration) === IsAllow.No
                        ? null
                        : taxDetailUIData(countryData, data.taxResidency)
                }
                errorSection={
                    props.errorSection?.section === ErrorSectionTypes.FatcaDetails
                        ? props.errorSection
                        : null
                }
            />
            <KycDetailsPurchase
                apiData={apiData}
                errorSection={props.errorSection}
                resetError={props.resetError}
            />
        </div>
    );
}
